// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"61":"a6872772","260":"50d5f771","669":"6d2fe627","739":"7879725b","819":"27f56b7c"}[chunkId] + ".chunk.js";
};